enum PlansEnum {
  Basic = 0,
  Pro = 1,
  Teams = 2,
}
export default PlansEnum
